import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import {
  RequestPurchases,
  RequestPurchasesQuery,
} from './RequestPurchase.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/requestPurchase`;

export async function listRequestPurchases(params: RequestPurchasesQuery) {
  const result = (await api.get(
    `${CONTROLLER_URL}/listrerequestpurchase`,
    params,
  )) as unknown;

  return result as PageResult<RequestPurchases>;
}

export const getRequestPurchase = async (requestPurchaseId?: number) => {
  const result = (await api.get(
    `${CONTROLLER_URL}/GetById?Id=${requestPurchaseId}`,
    null,
  )) as unknown;

  return result as RequestPurchases;
};
